export const COLOR_TAG = {
  MAIN: "/color-tag",
} as const;
